export const environment = {
  production: false,
  apiUrl: 'https://gmacbapitest.clavisco.com',
  name: 'Estados de cuenta Dr Max Staging',
  env: 'Staging'
};
